<template>
    <div class="main">

        <div class="banner">
            <div class="banner-left">
                <div class="title">{{$t('News.title')}}</div>
                <div class="title">{{$t('News.title2')}}</div>
                <div style="margin-top: 25px; margin-right: 115px;">
                    
                    <div class="content">{{$t('News.content')}}</div>
                    <div class="content">{{$t('News.content2')}}</div>
                   
                </div>

            </div>

            <div class="banner-right">
                <img :src="require('../assets/server/News.png')" alt="" />
            </div>
        </div>
        <Board></Board>
        <div class="container3">
            <div class="detail">
                <div class="title">{{ detail.title }}</div>
                <div class="meta-row">
                    <div class="date">{{$t('Detail.date')}}: {{ detail.createTime }}</div>
                    <div class="username">{{$t('Detail.user')}}: {{ detail.userName }}</div>
                </div>
                <div class="content" v-html="detail.content"></div>
            </div>
            <div class="line"></div>
            <div class="container4">
            <div class="previous" @click="prevArticle">{{$t('Detail.previous')}}</div>
            <div class="back" @click="$router.push({ name: 'News' })">{{$t('Detail.back')}}</div>
            <div class="next" @click="nextArticle">{{$t('Detail.next')}}</div>
            </div>


         
        </div>

        

    </div>
</template>

<script>
import Board from '@/components/Board.vue'
import { newsInfo, newsPage } from '@/api'

export default {
  name: 'Detail',
  components: { Board },
    data() {
        return {
            ecologySystems: [
                {
                    img: require('../assets/contribute/ecologySystem/crosschain.png'),
                    title: this.$t('contribute.module1.product[8].title'),
                    titleStyle: 'rgb(110 93 84)',
                    describe: this.$t('contribute.module1.product[8].describe'),
                },
                {
                    img: require('../assets/contribute/ecologySystem/webphone.png'),
                    title: this.$t('contribute.module1.product[9].title'),
                    titleStyle: 'rgb(32 35 54)',
                    describe: this.$t('contribute.module1.product[9].describe'),
                },
                {
                    img: require('../assets/contribute/ecologySystem/deepseek.png'),
                    title: this.$t('contribute.module1.product[10].title'),
                    titleStyle: 'rgb(73 99 252)',
                    describe: this.$t('contribute.module1.product[10].describe'),
                },
                {
                    img: require('../assets/contribute/ecologySystem/kimi.png'),
                    title: this.$t('contribute.module1.product[11].title'),
                    titleStyle: 'rgb(6 6 5)',
                    describe: this.$t('contribute.module1.product[11].describe'),
                },            
            ],
            publicProducts: [
                {
                    img: require('../assets/contribute/publicProduct/sentinel.png'),
                    title: this.$t('contribute.module2.product[0].title'),
                    titleStyle: 'rgb(130, 184, 255)',
                    describe: this.$t('contribute.module2.product[0].describe'),
                },
            ],
            detail: {
                title: '',
                userName: '',
                createTime: '',
                content: ''
            },
            listCache: []
        }
    },
    mounted() {
        this.loadDetail()
    },
    watch: {
        '$route.query.newNo'() {
            this.loadDetail()
        }
    },
    methods: {
        async loadDetail() {
            const newNo = Number(this.$route.query.newNo)
            if (!newNo) {
                console.warn('Missing newNo, return to News')
                return
            }
            try {
                const lang = localStorage.getItem('langue');
                const reqInfo = { newNo };
                if (lang !== null) {
                    reqInfo.isEnglish = (lang === 'en');
                }

                const res = await newsInfo(reqInfo)
                const result = res?.result ?? res?.data?.result ?? res
                this.detail.title = result?.title || ''
                this.detail.userName = result?.userName || ''
                this.detail.createTime = result?.createTime || ''
                this.detail.content = result?.content || ''
                console.log('news detail loaded:', this.detail)
            } catch (e) {
                console.error('Failed to load news detail:', e)
            }
        },  // comma added

        async ensureListCache() {
            if (Array.isArray(this.listCache) && this.listCache.length > 0) return
            try {
                const lang = localStorage.getItem('langue');
                const req = { pageNo: 1, pageSize: 200 };
                if (lang !== null) {
                    req.isEnglish = (lang === 'en');
                }

                const res = await newsPage(req)
                const result = res?.result ?? res?.data?.result ?? null
                const candidates = [result?.list, res?.list, res?.data?.list]
                this.listCache = candidates.find(arr => Array.isArray(arr)) || []
                console.log('listCache size:', this.listCache.length)
            } catch (e) {
                console.error('Failed to load news list:', e)
                this.listCache = []
            }
        },  // comma added

        getCurrentIndex() {
            const current = Number(this.$route.query.newNo)
            if (!current || !Array.isArray(this.listCache)) return -1
            return this.listCache.findIndex(i => Number(i?.newNo) === current)
        },  // comma added

        async prevArticle() {
            await this.ensureListCache()
            const idx = this.getCurrentIndex()
            if (idx > 0) {
                const prev = this.listCache[idx - 1]
                if (prev && prev.newNo) {
                    this.$router.push({ name: 'Detail', query: { newNo: prev.newNo } })
                }
            } else {
                console.warn('Already first or not found')
            }
        },  // comma added

        async nextArticle() {
            await this.ensureListCache()
            const idx = this.getCurrentIndex()
            if (idx >= 0 && idx < this.listCache.length - 1) {
                const next = this.listCache[idx + 1]
                if (next && next.newNo) {
                    this.$router.push({ name: 'Detail', query: { newNo: next.newNo } })
                }
            } else {
                console.warn('Already last or not found')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.main {
  width: 100%;
  margin-top: 50px;

   .banner {
    /* 固定画布宽度与居中 */
    
    margin: 0 auto;
    min-width: 1200px;
    position: relative;
    height: 576px;
    
    background-image: url('../assets/home/RWAbackground.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    /* 固定画布宽度，居中，不随视口变化 */
    width: 100%;
    
    
      display: flex;
        justify-content: center;
        align-items: center;
       
        box-sizing: border-box;

       .banner-left {
            flex: 1 1 auto;
            max-width: 1000px;
            text-align: left;
            z-index: 2;
            position: relative;
            left: 150px;
            /* 标题样式 */
            .title {
                color: #ffffff;
                font-size: 70px;
                font-weight: 700;
                line-height: 1.6;
                margin-bottom: 10px;
                font-family: 'Arial', sans-serif;
                max-width: 1600px;
            }
           
            /* 内容文本样式 */
            .content {
                font-family: 'Arial', sans-serif;
                font-size: 28px;
                font-weight: 400;
                color: #aaa9a9a2;
                max-width: 100%;
                line-height: 1.4;
            }
        }

        /* 横幅右侧图片区域 */
        .banner-right {
            top:10px;
            left:-150px;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 10;
            position: relative;
            
            img {
                width: 100%;
                height: auto;
                scale: 0.9;
                
            }
        }
  }
  .container3 {
    background-image: url('../assets/background/background2.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    /* 固定画布宽度与居中 */
    width: 100%;
    margin: 0 auto;
    position: relative;

   min-width: 1200px;


    padding-top: 50px;
  .detail{
    margin-bottom: 200px;
    .title{
         color: #ffffff;
              font-size: 64px;
              font-weight: 500;
              line-height: 1.5;
              margin-bottom: 0px;
              font-family: 'Arial', sans-serif;
              width: 1200px;
              position: relative;
              text-align: center;
              margin: 0 auto;
              
            

    }
    .meta-row {
        text-align: center;        /* 将子元素整体居中 */
    }
    .date{
        color: #727171;
        font-size: 20px;
        font-weight: 500;
        font-family: '微软雅黑';
        position: relative;
        left: 0;                   /* 取消原来向右偏移 */
        display: inline-block;     /* 同一行显示 */
        vertical-align: middle;
        margin-right: 20px;        /* 与用户名的间距 */
    }
    .username{
        color: #727171;
        font-size: 20px;
        font-weight: 500;
        font-family: '微软雅黑';
        position: relative;
        left: 0;                   /* 取消原来向右偏移 */
        display: inline-block;     /* 同一行显示 */
        vertical-align: middle;
    }
    .content{
        color: #b9b8b8;
        font-size: 20px;
        font-weight: 500;
        line-height: 1.8;    
        margin: 0 auto;         
        
        max-width: 62%;
        text-align: center;
    }
  }
  .line {
    width: 1190.4px;
    margin: 0 auto;              /* 居中 */
    border-top: 2px dashed #cfcfcf; /* 虚线（可调整颜色和粗细） */
    height: 0;                   /* 使用边框绘制，无需高度 */
   
    }
    .container4 {
        
    margin: 0 auto;
    position: relative;
    padding-bottom: 150px;
   width: 1920px;

     .previous {
      background-image: url('../assets/News/previous.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
      width: 345px;
      display: inline-block;     /* 同一行显示 */
      vertical-align: middle;
      margin: 0 30px;             /* 与相邻按钮的间距 */
      left: 360px;
      position: relative;
      margin-top: 40px;
      height: 50px;
      color: #ffffff;
      font-size: 20px;
      text-align: center;
      padding: 10px;
      
    }
    .back,
    .next {
      background-image: url('../assets/News/next.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
      width: 345px;
      display: inline-block;     /* 同一行显示 */
      vertical-align: middle;
      margin: 0 25px;            
      position: relative;
      left: 368px;
      margin-top: 40px;
      height: 50px;
       font-size: 20px;
      text-align: center;
      padding: 10px;
      color: #a5a2a2;
    }

.back {
  cursor: pointer;
}
}
}
}
</style>